import * as React from 'react'
import {useTranslation} from 'react-i18next'
import '../css/common.css'
import {ACCENT_TEXT, ACCENT_TEXT_FW500, setTitleFont, tagger} from '../util/util'
import {useEffect} from 'react'

const GDPR = () => {
    const {t, i18n} = useTranslation('gdpr')
    
    useEffect(() => {
        setTitleFont(i18n.language)
    }, [])
    
    return (
        <div className="common-pages-container">
            <p className="title muli">{tagger(t('personaly gdpr c'), ACCENT_TEXT)}</p>
            <div className="text">{tagger(t('the general data p'), ACCENT_TEXT_FW500)}</div>
            <div className="text">{tagger(t('personaly company is'), ACCENT_TEXT_FW500)}</div>

            <p className="title muli">{t('data processing')}</p>
            <div className="text">{tagger(t('company only processes p'), ACCENT_TEXT_FW500)}</div>
            
            <p className="title muli">{tagger(t('technological organizational'), ACCENT_TEXT_FW500)}</p>
            <div className="text">{tagger(t('the company completed'), '')}</div>
            
            <p className="title muli">{tagger(t('transparency and fairness'), ACCENT_TEXT_FW500)}</p>
            <div className="text">{t('company maintains a')}</div>
            
            <p className="title muli">{t('incident responsiveness')}</p>
            <div className="text">{tagger(t('company has the ability'), ACCENT_TEXT_FW500)}</div>

            <p className="title muli">{tagger(t('data protection officer'), ACCENT_TEXT_FW500)}</p>
            <div className="text">{tagger(t('company has appointed a'), 'text-underline')}</div>
        </div>
    )
}

export default GDPR


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/gdpr.tsx